var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Subject } from '@/models/Subject';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let ShowSwapTopicDialog = class ShowSwapTopicDialog extends Vue {
    constructor() {
        super(...arguments);
        this.selectedArea = '';
        this.selectedTopic = '';
        this.topics = [];
    }
    get currentCurriculum() {
        return this.$store.state.curriculum;
    }
    mounted() {
        //
    }
    closeDialog() {
        this.clear();
        this.$store.dispatch('selectedChanged', null);
        this.$emit('input', false);
    }
    clear() {
        this.selectedArea = '';
        this.selectedTopic = '';
        this.topics = [];
    }
    swap() {
        if (this.subject.depth === 1) {
            this.subject.parent = this.selectedArea;
        }
        else {
            this.subject.parent = this.selectedTopic;
        }
        this.subject.update({ parent: this.subject.parent }).then((subject) => {
            this.clear();
            this.$emit('subjectSwapped');
            this.$emit('input', false);
        });
    }
    getAreaChildren(id) {
        if (!this.currentCurriculum || !this.currentCurriculum.subjects) {
            return;
        }
        const area = this.currentCurriculum.subjects.find((area) => {
            return area.id === id;
        });
        if (area) {
            this.topics = area.children || [];
        }
    }
    areaSelected(id) {
        this.getAreaChildren(id);
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], ShowSwapTopicDialog.prototype, "subject", void 0);
__decorate([
    Watch('selectedArea'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ShowSwapTopicDialog.prototype, "areaSelected", null);
ShowSwapTopicDialog = __decorate([
    Component({
        components: {},
    })
], ShowSwapTopicDialog);
export default ShowSwapTopicDialog;
